var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "top-campaigns glide" }, [
      _c(
        "div",
        { staticClass: "glide__track", attrs: { "data-glide-el": "track" } },
        [_c("div", { staticClass: "glide__slides" }, [_vm._t("default")], 2)]
      ),
      _vm._v(" "),
      _c("div", { attrs: { "data-glide-el": "controls" } }, [
        _c(
          "button",
          {
            staticClass: "btn btn-glide prev",
            attrs: { "data-glide-dir": "<" }
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "13.097",
                  height: "23.925",
                  viewBox: "0 0 13.097 23.925"
                }
              },
              [
                _c("path", {
                  attrs: {
                    id: "arrow_left",
                    "data-name": "arrow left",
                    d:
                      "M373.177,465.635a.6.6,0,0,1,1.026-.426l10.4,10.4,10.4-10.4a.6.6,0,0,1,.851.851L385.03,476.888a.6.6,0,0,1-.851,0l-10.829-10.829A.59.59,0,0,1,373.177,465.635Z",
                    transform: "translate(477.63 -372.677) rotate(90)",
                    fill: "#fff",
                    stroke: "#fff",
                    "stroke-width": "1"
                  }
                })
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-glide next",
            attrs: { "data-glide-dir": ">" }
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "13.097",
                  height: "23.925",
                  viewBox: "0 0 13.097 23.925"
                }
              },
              [
                _c("path", {
                  attrs: {
                    id: "arrow_left",
                    "data-name": "arrow left",
                    d:
                      "M373.177,465.635a.6.6,0,0,1,1.026-.426l10.4,10.4,10.4-10.4a.6.6,0,0,1,.851.851L385.03,476.888a.6.6,0,0,1-.851,0l-10.829-10.829A.59.59,0,0,1,373.177,465.635Z",
                    transform: "translate(477.63 -372.677) rotate(90)",
                    fill: "#fff",
                    stroke: "#fff",
                    "stroke-width": "1"
                  }
                })
              ]
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }